<template>
  <div>
    <el-dialog class="main_dialog" :show-close="false" title="素材资产库" width="70%" :visible.sync="dialogMaterialVisible">
      <div class="select_dialog">
        <div class="tree_outbox">
          <el-tree :data="folderTree" ref="folderTree" :props="defaultProps" :default-expanded-keys="[...expandedKeys]" icon-class="el-icon-arrow-right el-icon-arrow-down" @node-click="treeNodeClick" node-key="id" highlight-current>
            <div slot-scope="{ node, data }">
              <img v-if="data.children" :src="require(`@/assets/images/folder-${node.expanded ? `o` : `c`}.png`)" class="folderimg" />
              <span>{{ node.label }}</span>
            </div>
          </el-tree>
        </div>
        <div class="select_dialog_r">
          <el-checkbox-group v-model="multipleSelection" class="material_r_grid" @change="handleSelectionChange">
            <div v-for="item in libraryTableData" :class="isFolder(item.type) ? 'material_grid_file' : 'material_grid_folder'">
              <el-checkbox :label="JSON.stringify(item)" :key="item.id" v-if="isFolder(item.type)"></el-checkbox>
              <div class="material_grid_mask">
                <!-- <div class="mask_opratebox">
                  <img src="@/assets/images/m-download.png" v-if="isFolder(item.type)" @click="downloadSingleImage(item.url, item.name)" />
                  <img src="@/assets/images/m-edit.png" v-if="!item.is_shared" @click="editSoleFolder(item)" />
                  <img src="@/assets/images/m-remove.png" v-if="!item.is_shared" @click="removeSingle(item)" />
                  <img src="@/assets/images/m-share.png" v-if="!item.is_shared" @click="specifyShared(item)" />
                  <img src="@/assets/images/m-delete.png" v-if="!item.is_shared" @click="batchDeletion(item)" />
                </div> -->
                <div class="mask_textbox" @dblclick="openFile(item)">
                  <div>{{ item.name }}</div>
                  <div class="mask_time">创建时间：{{item.create_time || '--'}}</div>
                  <div class="mask_time">创建时间：{{item.update_time || '--'}}</div>
                </div>
              </div>
              <el-image
                class="material-grid-img"
                v-if="isFolder(item.type)"
                :src="item.thumb"
                fit="contain"
              ></el-image>
              <img
                class="material-grid-img"
                v-else
                src="@/assets/images/folder.png"
              />
            </div>
          </el-checkbox-group>
          <el-pagination
            class="main_pagination"
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="searchForm.limit"
            :total="tableTotal">
          </el-pagination>
        </div>
      </div>
      <div style="text-align:right">
        <el-button class="dialog_confirm" size="small" @click="handleSubmitForm" :disabled="!multipleSelection.length">
          确 定<span v-if="multipleSelection.length">（已选{{multipleSelection.length}}）</span>
        </el-button>
        <el-button class="dialog_cancel" size="small" @click="dialogMaterialVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { materialGetList, folderGetTree } from '@/api/material'
export default {
  name: "SelectMaterial",
  data () {
   return {
    dialogMaterialVisible: false,

    expandedKeys: [0,],
    currentFolderName: '全部',
    folderTree: [{
      id: 0,
      name: "全部",
      type: 1,
      children: []
    }],
    defaultProps: {
      // children: 'children',
      label: 'name'
    },

    libraryTableData: [],
    tableTotal: 0,
    multipleSelection: [],
    searchForm: {
      parent_id: 0,
      page: 1,
      limit: 20
    },
   }
  },
  // created() {
  //       this.getFolderTree()
  //       this.getMaterialList()
  //     },
  watch: {
    dialogMaterialVisible(val) {
      if(val) {
        this.multipleSelection = []
        this.getFolderTree()
        this.getMaterialList()
      }
    }
  },
  methods:{
    // 点击文件夹目录时
    treeNodeClick(data) {
      this.currentFolderName = data.name
      this.searchForm.parent_id = data.id;
      this.searchForm.page = 1;
      this.multipleSelection = [];
      this.getMaterialList();
      // }
    },
    // 双击打开文件夹
    openFile(item) {
      this.multipleSelection = []
      this.searchForm.page = 1;
      this.currentFolderName = item.name
      // this.expandedKeys.push(item.id)
      this.expandedKeys[1] = item.id
      this.$refs.folderTree.setCurrentKey(item.id);
      this.searchForm.parent_id = item.id
      this.getMaterialList();
    },
    /* 表格选中事件 */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSubmitForm() {
      let urldata = this.multipleSelection.map(item => { return {url: JSON.parse(item).url, image_title: JSON.parse(item).image_title}})
      this.$emit('handleSelect', urldata)
      this.dialogMaterialVisible = false
    },
    getMaterialList() {
      this.tableLoading = true
      materialGetList(this.searchForm).then((res) => {
        this.libraryTableData = res.data.data
        this.tableTotal = res.data.total;
        this.tableLoading = false;
      });
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getMaterialList();
    },
    /*
      判断文件类型
      为1是普通文件夹，2是文件
    */
    //
    isFolder(type) {
      return type == 2;
    },
    getFolderTree() {
      folderGetTree().then(res => {
        this.folderTree[0].children = res.data
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.select_dialog {
  display: flex;

  .tree_outbox {
    flex-shrink: 0;
    width: 20%;
    margin-right: 32px;
    // flex: 1;
    overflow-y: auto;
    // padding-bottom: 16px;
    .el-tree {
      background: transparent;
      // color: #FFFFFF;
      /deep/ .el-tree-node:focus>.el-tree-node__content {
        background: transparent;
      }
      /deep/ .el-tree-node.is-current>.el-tree-node__content {
        background: rgba(204, 204, 204, 0.25);
        border-radius: 4px;
      }
      /deep/ .el-tree-node__content {
        margin-top: 18px;
        font-size: 14px;
        height: 32px;
        .el-tree-node__expand-icon {
          // color: #FFFFFF;
          &.is-leaf {
            color: transparent;
          }
        }
        .folderimg {
          margin-right: 12px;
          vertical-align: bottom;
        }
        &:hover {
          background: transparent;
        }
      }
      /deep/ .el-tree-node__children .el-tree-node__content {
        margin-top: 12px;
      }
    }
  }
  .select_dialog_r {
    flex: 1;
    .material_r_grid {
      margin-top: 32px;
      margin-bottom: 32px;
      // height: 72vh;
      // overflow: auto;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      gap: 1.25%;
      .material_grid_file, .material_grid_folder {
        width: 19%;
        position: relative;
        border: 1px solid #F7F8FA;
        margin-bottom: 16px;
        .el-checkbox {
          position: absolute;
          z-index: 2;
          margin-top: 16px;
          margin-left: 8px;
          /deep/ .el-checkbox__inner {
            background: transparent;
            border-color: #1e55d3;
            &::after {
              border-color: #1e55d3;
            }
          }
          /deep/ .el-checkbox__label {
            display: none;
          }
        }
        .material_grid_mask {
          position: absolute;
          z-index: 1;
          width: 100%;
          height: 100%;
          background: rgba(21, 26, 48, 0.4);
          box-shadow: 0px 0px 4px  rgba(0, 0, 0, 0.15);
          display: none;
          align-items: flex-end;
          .mask_textbox {
            width: 100%;
            padding: 12px 8px 18px;
            background: #FFFFFF;
            // color: #FFFFFF;
            font-size: 14px;
            cursor: pointer;
            div {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .mask_time {
              color: #BFBFBF;
              font-size: 12px;
              margin-top: 4px;
            }
          }
        }
        &::after {
          padding-top: 100%;
          content: '';
          display: block;
        }
        .material-grid-img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: contain;
          vertical-align: middle;
        }
        &:hover .material_grid_mask {
          display: flex;
        }
      }
      .material_grid_file {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAIAAABLixI0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFHGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDUgNzkuMTYzNDk5LCAyMDE4LzA4LzEzLTE2OjQwOjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDE5LTEwLTIyVDE2OjMxOjQ5KzA4OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAxOS0xMC0yMlQxNjozMzoyMiswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAxOS0xMC0yMlQxNjozMzoyMiswODowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIuMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpmZGJmY2E1NC04Yzc4LTk3NGMtOGYyNC0xMmQ5MTMxNDI1ODgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ZmRiZmNhNTQtOGM3OC05NzRjLThmMjQtMTJkOTEzMTQyNTg4IiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6ZmRiZmNhNTQtOGM3OC05NzRjLThmMjQtMTJkOTEzMTQyNTg4Ij4gPHhtcE1NOkhpc3Rvcnk+IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDpmZGJmY2E1NC04Yzc4LTk3NGMtOGYyNC0xMmQ5MTMxNDI1ODgiIHN0RXZ0OndoZW49IjIwMTktMTAtMjJUMTY6MzE6NDkrMDg6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE5IChXaW5kb3dzKSIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6l0qErAAAASklEQVQ4je3TwQkAMQhEUWdJYZZuW4JgOohzCSxk5vx5B0F0t02LiLExs4+JyMmS9aK1yF+jLLJz97H5671kybppsT9UVZl5CABsVSkOV58tY+kAAAAASUVORK5CYII=);
        background-repeat: repeat;
        .material-grid-img {
        }
      }
      .material_grid_folder {
        background: #F7F8FA;
        .material-grid-img {
          width: 36%;
          height: 36%;
          transform: translate(50%, 50%);
          margin-top: 14%;
          margin-left: 14%;
        }
      }
    }
    .main_pagination {
      background: transparent;
      border-color: transparent;
    }
  }
}
.dialog_confirm {
  transition: all .7s;
  &.is-disabled {
    width: 96px !important;
  }
  width: 127px !important;
}
</style>